module.exports = __webpack_public_path__ + "img/manage11.ea06b658.png";